<template>
    <vx-card :title="title" :title-color="titleColor">
        <div class="flex items-center user_label">
            <vs-avatar size="32px" v-if="item.avatar" :src="item.avatar" class="ml-0" text="Luisd"/>
            <vs-avatar size="32px" v-else class="ml-0" :text="avatarText"/>
            <div class="user_info">
                <div class="name">{{userName}}</div>
            </div>
        </div>
        <div class="user_contact mt-2 pt-2 border border-r-0 border-b-0 border-l-0 border-solid d-theme-border-grey-light" v-if="item.email || item.phone">
            <div v-if="item.email" class="item flex items-center">
                <feather-icon svg-classes="w-5 h-5" class="mr-2" icon="MailIcon" />
                <a class="break-all text-black" :href="`mailto:${ item.email }`">{{item.email}}</a>
            </div>
            <div v-if="item.phone" class="item flex items-center">
                <feather-icon class="mr-2" icon="PhoneIcon" />
                <a class="break-all text-black" :href="`tel:${ item.phone }`">{{item.phone}}</a>
            </div>
        </div>
        <vs-button
            v-if="user.profileId !== item.profileId"
            color="primary"
            @click="userMessage()"
            icon-pack="feather"
            icon="icon-message-square"
            size="small"
            class="mt-2"
            type="filled">
                {{$t('write_a_message')}}
        </vs-button>


        <vs-button
            v-if="isVisors=='true'"
            color="primary"
            icon-pack="feather"
            icon="icon-message-square"
            size="small"
            @click="openChangeVisor('openChangeVisor')"
            class="mt-2"
            type="filled">
                Сменить
        </vs-button>


        <vs-button
            v-if="isVisors=='true'"
            color="primary"
            icon-pack="feather"
            icon="icon-message-square"
            size="small"
            @click="openChangeVisor('openStoryVisor')"
            class="mt-2"
            type="filled">
                История
        </vs-button>


    </vx-card>
</template>

<script>
import {mapState} from 'vuex'
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        titleColor: {
            type: String,
            default: ''
        },
        item: Object,
        isVisors:{
            type: String,
            default: 'false'
        }
    },
    methods: {
        userMessage() {
            this.$router.push({name: 'chat', query: {user: this.item.profileId}})
        },
        openChangeVisor(fn_name){
            this.$emit(fn_name,true);
        }
    },
    computed: {
        ...mapState({
            user: state => state.user.user
        }),
        userName() {
            // Возвращаем имя человека целиком
            return `${ this.item.lastName } ${ this.item.firstName } ${ this.item.middleName }`
        },
        avatarText() {
            // Если нет аватара подставляем инициалы
            let title,
                text = this.userName
            const textAr = text.split(' ')
            if (textAr.length) {
                const newTitle = []
                textAr.forEach(item => {
                    newTitle.push(item.substr(0, 1).toUpperCase())
                })
                title = newTitle.join('')
            } else title = text.substr(0, 1)
            return title
        }
    }
}
</script>

<style scoped lang="scss">
@media only screen and (min-width: 1000px) and (max-width: 1460px) {
    .user_label{
        display: block!important;
    }
}
</style>
